module.exports = __webpack_public_path__ + "static/img/bg_benefit_four.f50e67b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_benefit_four.png
// module id = sG9Z
// module chunks = 0